<div class="@keyframes animacionFondo">
  <!--<app-homebtn></app-homebtn>-->
  <app-reload-btn></app-reload-btn>


    <div class="plantillaEvento">
      <h2>{{nombreEvento}}</h2>
      <img  class="imgLogoRadio"src="http://www.consuelofm.cl/Logo_Consuelo2.jpg" alt="logoPlay">
    </div>
    <div *ngIf="showStopButton" class="@keyframes outer-circle"></div>
    <div *ngIf="showStopButton" class="@keyframes outer-circle-2"></div>


          <div class="divBoton">
            <audio id="demo" src="{{url}}" type="audio/mpeg" preload="none"></audio>
            <!--<audio id="demo"  src="{{url}}" type="audio/ogg"></audio>-->
          </div>

            <div *ngIf="showPlayButton"
              (click)="showPlayButton=!showPlayButton; showStopButton=!showStopButton;"
              type="button" class="btn playButton"
              onclick="document.getElementById('demo').play()">
              <span class="material-icons">
                play_arrow
                </span>
              <!--
              <div class="@keyframes mensajePulsar">
                <span>Pulsa Para Escuchar</span>
              </div>
            -->
            </div>


            <div *ngIf="showStopButton"
              (click)="showPlayButton=!showPlayButton; showStopButton=!showStopButton;"
              type="button" class="btn stopButton"
              onclick="document.getElementById('demo').pause()">
              <span class="material-icons">
                stop
                </span>
            </div>

          <app-publicidadck></app-publicidadck>
  </div>
